import request from '@/utils/request'

// 获取价格档位列表
export function getProductList(params) {
  return request({
    url: '/ai/product/list',
    method: 'get',
    params
  })
}

// 使用兑换码
export function useCode(data) {
  return request({
    url: '/ai/product/useCode',
    method: 'post',
    data
  })
}
